module.exports = __webpack_public_path__ + "media/images/svg/back-btn-white-845ccc1b8878ac4527ea09bd5eff961a.svg";